import { axios } from "./axiosSettings";
import { getAuthToken } from "../helpers/session";
import { logger } from "./logger";

export const fetchLatestGeneratorData = async (vesselId) => {
  try {
    const { data } = await axios.get("/latestData/vesselGeneratorEngineData", {
      params: {
        vessel_id: vesselId,
      },
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    });
    return data;
  } catch (e) {
    logger.error(`fetchLatestGeneratorData error ${e}`);
    throw e;
  }
};

export const fetchLatestShaftGeneratorData = async (vesselId) => {
  try {
    const { data } = await axios.get("/latestData/vesselShaftGeneratorEngineData", {
      params: {
        vessel_id: vesselId,
      },
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    });
    return data;
  } catch (e) {
    logger.error(`fetchLatestShaftGeneratorData error ${e}`);
    throw e;
  }
};
